import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '../../models/request-state';
import { DecsRequest } from './models/request/decs.request';
import { DecsResponse } from './models/response/decs.response';
import { ApiCacheService } from '../api-cache.service';

/**
 * Service for interacting with sabre/decs endpoint. Used for requests when raw Sabre text
 * is desired.
 */
@Injectable({
  providedIn: 'root',
})
export class DecsService {
  private readonly _decsUrl = `${environment.apiUrl}Sabre/decs`;
  private readonly _resUrl = `${environment.apiUrl}Sabre/res`;

  constructor(private cacheService: ApiCacheService) {}

  /** Standard method to submit DECS request. Follows cache strategy. */
  submitResRequest(
    decsRequest: DecsRequest,
    isRefresh = false
  ): Observable<RequestState<DecsResponse>> {
    const cacheId = this.getCacheId(decsRequest);

    if (isRefresh) {
      return this.cacheService.forceRefreshPost<DecsResponse>(
        cacheId,
        this._resUrl,
        decsRequest
      );
    }

    return this.cacheService.request<DecsResponse>(
      cacheId,
      this._resUrl,
      decsRequest
    );
  }

  /** Standard method to submit DECS request. Follows cache strategy. */
  submitDecsRequest(
    decsRequest: DecsRequest,
    isRefresh = false
  ): Observable<RequestState<DecsResponse>> {
    const cacheId = this.getCacheId(decsRequest);

    if (isRefresh) {
      return this.cacheService.forceRefreshPost<DecsResponse>(
        cacheId,
        this._decsUrl,
        decsRequest
      );
    }

    return this.cacheService.request<DecsResponse>(
      cacheId,
      this._decsUrl,
      decsRequest
    );
  }

  /** Unique string for this request. */
  getCacheId(decsRequest: DecsRequest): string {
    return `decs-${decsRequest.cmd}`;
  }
}
